import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="maps--geocoding"
export default class extends Controller {
  static values = { address: String, link: String };
  static targets = [
    "countryName",
    "cityName",
    "addressLine1",
    "addressLine2",
    "landmark",
    "postalCode",
    "latitude",
    "longitude",
    "trigger",
    "concealer",
  ];

  connect() {
    if (this.landmarkTarget.value !== "") {
      this.concealerTarget.disabled = false;
    }

    if (this.concealerTarget.checked) {
      this.addressValue = this.landmarkAddress;
    } else {
      this.addressValue = this.address;
    }
  }

  manageConcealerInteractivity() {
    if (this.landmarkTarget.value === "") {
      this.concealerTarget.disabled = true;
    } else {
      this.concealerTarget.disabled = false;
    }
  }

  async fetchCoordinates() {
    this.updateAddress();
    const addressParams = new URLSearchParams({ address: this.addressValue });
    this.triggerTarget.disabled = true;
    const response = await fetch(`${this.linkValue}?${addressParams}`);
    const data = await response.json();
    if (data.status === "OK") {
      const { coordinates } = data;
      this.latitudeTarget.value = coordinates.lat;
      this.longitudeTarget.value = coordinates.lng;
    }
    this.triggerTarget.disabled = false;
  }

  updateAddress() {
    if (this.concealerTarget.checked) {
      this.addressValue = this.landmarkAddress;
    } else {
      this.addressValue = this.address;
    }
  }

  get address() {
    return [
      this.addressLine1Target.value,
      this.addressLine2Target.value,
      this.cityNameTarget.options[this.cityNameTarget.selectedIndex].text,
      this.countryNameTarget.value,
      this.postalCodeTarget.value,
    ]
      .filter((str) => str.trim() !== "")
      .join(", ");
  }

  get landmarkAddress() {
    return [
      this.landmarkTarget.value,
      this.cityNameTarget.value,
      this.countryNameTarget.value,
      this.postalCodeTarget.value,
    ]
      .filter((str) => str.trim() !== "")
      .join(", ");
  }
}
